// extracted by mini-css-extract-plugin
export default {"container":"Interactive_container__1fbfi"};